import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shiftFilter'
})
export class ShiftFilterPipe implements PipeTransform {

  transform(shifts: any[]): any[] {

    //console.log(shifts)

    let returnShifts = []

    shifts.forEach(shift => {
      
      let rs = returnShifts.find(rs => rs.name == shift.name)
      if (!rs) {
        returnShifts.push({ name: shift.name, ids: [shift.id] })
      } else {
        rs.ids.push(shift.id)
      }

    })

    //console.log(returnShifts)

    return returnShifts

  }

}
